import { SET_FILTRAGE, SET_FETCH, SET_LOADING, SET_SIDEBAR, SET_TOPBAR, SET_IP_ADDRESS } from '../actions/constants.js'

const initialState = {
    filtrage: { aidActive: false, oidActive: false },
    fetch: false,
    loading: false,
    sidebar: 'activites',
    topbar: '',
    ipAddress: ''
};

const configReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_FILTRAGE:
            return {
                ...state,
                filtrage: payload
            }
        case SET_FETCH:
            return {
                ...state,
                fetch: payload
            }
        case SET_LOADING:
            return {
                ...state,
                loading: payload
            }
        case SET_SIDEBAR:
            return {
                ...state,
                sidebar: payload
            }
        case SET_TOPBAR:
            return {
                ...state,
                topbar: payload
            }
        case SET_IP_ADDRESS:
            return {
                ...state,
                ipAddress: payload
            }
        default:
            return state;
    }
}

export default configReducer